"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createConnect_1 = require("./createConnect");
var item_1 = require("../immutable/item");
var immutable_1 = require("immutable");
var patchItems = function (analytics, meta) { return function (item) { return new item_1.Item(item, meta, analytics); }; };
exports.default = createConnect_1.default({
    field: 'items',
    mapProps: function (items, meta, change, analytics) { return ({
        items: items && items.map(patchItems(analytics, meta)) || immutable_1.Map()
    }); },
});
//# sourceMappingURL=connectItems.js.map